import React from "react";
import { useTranslation } from "react-i18next";
import { useFeaturedContent } from "../../hooks/useFeaturedContent";
import Skeleton from "react-loading-skeleton";
import Icon from "../../../../../common/components/Icon/Icon";

const PanelFeaturedCategories: React.FC = () => {
  const { t } = useTranslation();
  const { categories, isLoading } = useFeaturedContent();

  if (isLoading) {
    return (
      <div className="panel-featured-categories">
        <h3 className="panel-featured-categories__title">
          <Skeleton width={150} />
        </h3>
        <div className="panel-featured-categories__list">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} style={{ marginBottom: "8px" }}>
              <Skeleton height={24} width="100%" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (categories.length === 0) {
    return null;
  }

  return (
    <div className="panel-featured-categories">
      <h3 className="panel-featured-categories__title">
        {t("featuredContent.categoriesTitle", "Popular Categories")}
      </h3>
      <div className="panel-featured-categories__list">
        {categories.map((cat) => (
          <a
            key={cat.id}
            href={cat.link}
            className="panel-featured-categories__item"
          >
            <span>{cat.name}</span>
            <Icon iconName="chevron-down" className="icon-rotate-right" />
          </a>
        ))}
      </div>
    </div>
  );
};

export default PanelFeaturedCategories;
